export default "__VITE_ASSET__041a0b07__";